angular.module('impactx.catalog').controller('CatalogApprovalCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'CatApprovalService',
    'BackService',
    '$mdToast',
    '$mdDialog',
    '$redirect',
    'ToastService',
    'TranslationService',
    'ToolbarService',
    CatalogApprovalCtrl
]);

function CatalogApprovalCtrl($scope, dataGen, $routeParams, CatApprovalService, BackService, $mdToast, $mdDialog, $redirect, ToastService, TranslationService, ToolbarService) {
    var self = this;
    dataGen.getData($scope, {id: $routeParams.id}, '/catalog/detail/approval').then(function () {
        defineButtons();
    });

    self.approveTechnical = function (event) {
        CatApprovalService.approveCatalogs([$scope.data.atiId], BackService.back, event);
    };

    self.approveProfessional = function (event) {
        CatApprovalService.approveCatalogs([$scope.data.atiId], BackService.back, event);
    };

    self.deny = function () {
        CatApprovalService.denyCatalogs([$scope.data.atiId], function () {
            $redirect.redirectTo(null, "/cataloglist");
        });
    };

    self.doneForward = function () {
        CatApprovalService.doneForward($scope.data.id, BackService.back);
    };

    self.stop = function (event) {
        CatApprovalService.stopCatalog($scope.data.catId, BackService.back, event);
    };

    self.abortApprovalProcess = function (event) {
        var confirm = $mdDialog.confirm()
            .title($scope.trns.abortApprovalQuestion)
            .textContent($scope.trns.abortApprovalQuestion2)
            .targetEvent(event)
            .ok($scope.trns.abortApproval)
            .cancel(TranslationService.get('back'));

        return $mdDialog.show(confirm).then(function () {
            dataGen.postAsForm({}, {cat: {id: $scope.data.catId}}, "/catalog/abortApproval").then(function (data) {
                ToastService.openStandardToast(data.trns.abortSuccess);
                $redirect.reload();
            });

        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.catalog,
                linkFunction: getInternalCatalogLink,
                type: 'link',
                condition: isNotSupplier
            },
            {
                label: $scope.trns.catalog,
                linkFunction: getInternalCatalogSupplierLink,
                type: 'link',
                condition: isSupplier
            },
            {
                label: $scope.trns.stop,
                action: self.stop,
                type: 'dialogaction',
                condition: canStop
            },
            {
                label: $scope.trns.deny,
                action: self.deny,
                type: 'dialogaction',
                condition: canDenyProfessional
            },
            {
                label: $scope.trns.approve,
                action: self.approveProfessional,
                type: 'dialogaction',
                condition: canApproveProfessional
            },
            {
                label: $scope.trns.deny,
                action: self.deny,
                type: 'dialogaction',
                condition: canDenyTechnical
            },
            {
                label: $scope.trns.approve,
                action: self.approveTechnical,
                type: 'dialogaction',
                condition: canApprovalTechnical
            },
            {
                label: $scope.trns.abortApproval,
                action: self.abortApprovalProcess,
                type: 'dialogaction',
                condition: canAbortApproval
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function getInternalCatalogLink() {
        return "internalcatalog/" + $scope.data.catId;
    }

    function getInternalCatalogSupplierLink() {
        return "internalcatalogsupplier/" + $scope.data.catId;
    }

    function isSupplier() {
        return $scope.data.isSupplier;
    }

    function isNotSupplier() {
        return !isSupplier();
    }

    function canStop() {
        return $scope.data.mayStop;
    }

    function canDenyProfessional() {
        return $scope.data.mayDenyProfessional;
    }

    function canDenyTechnical() {
        return $scope.data.mayDenyTechnical;
    }

    function canApproveProfessional() {
        return !$scope.data.hadCheckError && $scope.data.mayApproveProfessional;
    }

    function canApprovalTechnical() {
        return $scope.data.mayApproveTechnical;
    }

    function canAbortApproval() {
        return $scope.data.mayAbortApprovalProcess;
    }
}
